import { modelConfiguratorActions } from '../../services';

export const modelConfiguratorReducer = ( state = {}, action ) => {
  if ( !action || !action.type ) {
    return state;
  }
  let newState = {...action.initialState,...state};
  switch ( action.type ) {
    case modelConfiguratorActions.ADD:     
      if( action.item && !newState[action.item] ) {
        newState[action.item] = action.amount;
      } 
      return newState;
    case modelConfiguratorActions.SETAMOUNT:
      if( action.item ) {
        newState[action.item] = action.amount;
      } 
      return newState;
    case modelConfiguratorActions.RESET:
      return {};
    default:
      return state;
  }
};